import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import { DATE_FORMAT_URL } from '../../../../data/constants/datetime';
import { useI18n } from '../../../../data/hooks/i18nHooks';
import { useScheduleEnabled } from '../../../../data/hooks/schedule/useScheduleEnabled';
import { useSelectedSessions } from '../../../../data/hooks/schedule/useSelectedSessions';
import { useSelectableUnselectedSessions } from '../../../../data/hooks/schedule/useSelectableUnselectedSessions';
import { eventMomentFactory } from '../../../../data/misc/eventMomentFactory';
import { EVENT_SCHEDULE_TAB_PROGRAM } from '../../../screens/EventSchedule/schedule-header-tabs';
import Link from '../../Link';
import Tooltip from '../../Tooltip/Tooltip';
import Icon from '../../icons/Icon';
import styles from './ScheduleIcon.module.scss';
import { useEventSchedule } from '../../../../data/hooks/schedule/useEventSchedule';

const CLOSED = {};

const ScheduleIcon = (props) => {
    const { event, isActive } = props,
        i18n = useI18n(),
        allSessions = useEventSchedule(event.id),
        scheduleEnabled = useScheduleEnabled(event.id),
        futureUnselected = useSelectableUnselectedSessions(event.id, { filter: (s) => moment().isBefore(s.start_utc) }),
        selectedSessions = useSelectedSessions(event.id),
        targetRoute = ['/events', event.id, 'schedule'],
        showWarning = event.settings.workshop_selection && futureUnselected.length && !selectedSessions.length,
        [closed, setClosed] = useState(!!CLOSED[event.id]),
        [disablePermanent, setDisablePermament] = useState(false),
        string = i18n['hint.select-a-session'];

    if (showWarning) {
        targetRoute.push(eventMomentFactory(event, futureUnselected[0].start_local).format(DATE_FORMAT_URL));
        targetRoute.push(EVENT_SCHEDULE_TAB_PROGRAM);
    }

    useEffect(() => {
        if (closed) {
            CLOSED[event.id] = true;

            let timeout = setTimeout(() => setDisablePermament(true), 1000);
            return () => clearTimeout(timeout);
        }
    }, [closed, event]);

    const handleClose = useCallback(() => {
        setClosed(true);
    }, []);

    if (!scheduleEnabled) return null;
    if (!allSessions.length) return null;

    return (
        <Link href={targetRoute.join('/')}>
            <Icon icon="event-schedule" selected={isActive}>
                {showWarning ? (
                    <>
                        <div className={['Bubble', styles.bubble].join(' ')}>!</div>
                        <Switch>
                            {!disablePermanent ? (
                                <Route path="/events/:eventId" exact>
                                    <Tooltip className={[styles.tooltip, styles.visible, closed ? styles.hidden : ''].join(' ')} onClose={handleClose}>
                                        {string}
                                    </Tooltip>
                                </Route>
                            ) : null}
                            <Tooltip className={styles.tooltip}>{string}</Tooltip>
                        </Switch>
                    </>
                ) : null}
            </Icon>
        </Link>
    );
};

export default ScheduleIcon;
